import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BodyWrapper from "../../../utils/BodyWrapper";
import FormComponent from "../../../components/FormComponent";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { API } from "../../../App";
import { Box } from "@mui/material";

function AdminNewCategory(props) {
  const categoryId = props.match?.params.categoryId;
  const navigate = useNavigate();
  const [input, setInput] = useState({});

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const handleCheckChange = (e) => {
    const { name, checked } = e.target;
    setInput({
      ...input,
      [name]: checked,
    });
  };

  const getCategory = async () => {
    if (!categoryId) return;
    const categoryResponse = await fetch(
      `${API}/api/admin/categories/${categoryId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage["tk"]}`,
        },
      }
    )
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }
        if (res.status === 401) {
          window.location.href = "/admin";
        }
        return null;
      })
      .catch((err) => console.log(err));
    if (categoryResponse) {
      setInput(categoryResponse);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = {
      title: input.title,
      showInHome: input.showInHome,
      categoryId,
      active: input.active,
      order: input.order,
    };
    try {
      let path = `${API}/api/admin/categories/`;
      let method = "POST";
      if (categoryId) {
        method = "PUT";
      }
      const response = await fetch(path, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage["tk"]}`,
        },
        body: JSON.stringify(body),
      }).then((res) => res.json());
      if (response.id) {
        navigate("/admin/panel/2");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getCategory();
  }, []);
  return (
    <>
      <button
        onClick={() => window.history.back()}
        className="categoryposts__backBtn"
      >
        <ArrowBackIosNewIcon />
      </button>
      <BodyWrapper>
        <Box sx={{ width: "900px" }}>
          <FormComponent
            handleSubmit={handleSubmit}
            inputs={[
              {
                name: "title",
                type: "text",
                handleChange: handleChange,
                value: input.title,
                label: "Nombre de categoría",
              },
              {
                name: "order",
                type: "text",
                label: "Órden",
                handleChange: handleChange,
                value: input.order,
              },
              {
                name: "showInHome",
                type: "checkbox",
                handleChange: handleCheckChange,
                checked: input.showInHome,
                label: "Mostrar en el home",
              },
              {
                name: "active",
                type: "checkbox",
                handleChange: handleCheckChange,
                checked: input.active,
                label: "Publicación activa?",
              },
            ]}
          />
        </Box>
      </BodyWrapper>
    </>
  );
}

export default AdminNewCategory;
